var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5643 8.01738H9.79863V4.87676C9.79863 4.77363 9.71426 4.68926 9.61113 4.68926H8.20488C8.10176 4.68926 8.01738 4.77363 8.01738 4.87676V8.01738H5.25176C5.14863 8.01738 5.06426 8.10176 5.06426 8.20488V9.61113C5.06426 9.71426 5.14863 9.79863 5.25176 9.79863H8.01738V12.9393C8.01738 13.0424 8.10176 13.1268 8.20488 13.1268H9.61113C9.71426 13.1268 9.79863 13.0424 9.79863 12.9393V9.79863H12.5643C12.6674 9.79863 12.7518 9.71426 12.7518 9.61113V8.20488C12.7518 8.10176 12.6674 8.01738 12.5643 8.01738ZM19.2205 17.9549L15.7986 14.533C18.6604 11.0432 18.4611 5.87285 15.1893 2.60332C11.7205 -0.867773 6.08613 -0.867773 2.60332 2.60332C-0.867773 6.08613 -0.867773 11.7205 2.60332 15.1893C5.87285 18.4611 11.0432 18.6604 14.533 15.7986L17.9549 19.2205C18.0299 19.2861 18.1494 19.2861 18.2127 19.2205L19.2205 18.2127C19.2861 18.1494 19.2861 18.0299 19.2205 17.9549ZM13.9471 13.9471C11.1627 16.7291 6.65332 16.7291 3.86895 13.9471C1.08691 11.1627 1.08691 6.65332 3.86895 3.86895C6.65332 1.08691 11.1627 1.08691 13.9471 3.86895C16.7291 6.65332 16.7291 11.1627 13.9471 13.9471Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInOutlined);
export default __webpack_public_path__ + "static/media/ZoomInOutlined.c86339163d6fb6f5210f6d5331e75dad.svg";
export { ForwardRef as ReactComponent };